import { motion } from 'framer-motion';

import FactsImage from '@/assets/img/feature-screenshots/facts.png';
import InconsistenciesImage from '@/assets/img/feature-screenshots/inconsistencies.png';
import KimImage from '@/assets/img/feature-screenshots/kim.png';
import { Icon } from '@/new/components/icon';

export function SampleMatterLoader() {
  return (
    <motion.div
      key="loading"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 40 }}
      transition={{ duration: 0.35, ease: 'easeOut' }}
      className="-mt-14 flex h-full flex-col items-center justify-center gap-1"
    >
      <h2 className="mt-5 flex items-center gap-5 font-serif text-3xl font-medium">
        <Icon className="lucide--loader mt-0.75 animate-spin text-3xl text-gray-500 ease-in-out" />
        Preparing your Sample Matter...
      </h2>

      <p className="mt-6 mb-8 max-w-md text-center text-balance text-gray-600">
        This will only take a minute or so. When you get there, start by exploring:
      </p>

      <div className="group mt-4 flex w-full max-w-5xl gap-5">
        <div className="w-full space-y-3 grayscale duration-150 not-hover:group-hover:opacity-50 hover:grayscale-0">
          <img
            src={FactsImage}
            alt="Facts in Wexler"
            className="rounded border border-gray-100 shadow-teal-500 group-hover:shadow-lg/6"
          />
          <div className="space-y-1.25">
            <p className="flex items-center gap-1.5 font-medium">
              <Icon className="lucide--search mb-px text-gray-600" /> Facts and Chronologies
            </p>
            <p className="text-xs text-gray-500">Find key events and export a structured timeline.</p>
          </div>
        </div>

        <div className="w-full space-y-3 grayscale duration-150 not-hover:group-hover:opacity-50 hover:grayscale-0">
          <img
            src={KimImage}
            alt="Kim in Wexler"
            className="rounded border border-gray-100 shadow-teal-500 group-hover:shadow-lg/6"
          />
          <div className="space-y-1.25">
            <p className="flex items-center gap-1.5 font-medium">
              <Icon className="lucide--bot mb-px text-gray-600" />
              Kim Questions
            </p>
            <p className="text-xs text-gray-500">
              Query your entire document set and get referenced answers always rooted in your dataset.
            </p>
          </div>
        </div>

        <div className="w-full space-y-3 grayscale duration-150 not-hover:group-hover:opacity-50 hover:grayscale-0">
          <img
            src={InconsistenciesImage}
            alt="Inconsistencies in Wexler"
            className="rounded border border-gray-100 shadow-teal-500 group-hover:shadow-lg/6"
          />
          <div className="space-y-1.25">
            <p className="flex items-center gap-1.5 font-medium">
              <Icon className="lucide--shield-alert mb-px text-gray-600" />
              Inconsistencies
            </p>
            <p className="text-xs text-gray-500">Surface critical contradictions between facts.</p>
          </div>
        </div>
      </div>
    </motion.div>
  );
}
